module.exports = __webpack_public_path__ + "img/bg-moving.f8220603.png";